import type { Poll } from 'schema/poll';
import { getQuestionGroupId } from '../selects';

/** Проверяет инварианты опроса, которые невозможно проверить системой типов */
export function assertPollInvariants(poll: Poll) {
  assertAuthPageInvariants(poll);
}

/** Вопросы авторизации не могут быть в группе/странице */
function assertAuthPageInvariants(poll: Poll) {
  for (const question of poll.questions) {
    if (question.data.type === 'POLL_AUTH' && !!getQuestionGroupId(question, poll.questionDecks)) {
      throw new Error("Auth page can't be on the group!");
    }
  }
}
